import { css, customElement, GenesisElement, html } from '@genesislcap/web-core';
import { chartsGradients } from '@genesislcap/g2plot-chart';

const data = Array.from({ length: 30 }).map((item, index) => {
  return {
    label: index,
    value: Math.random() * 100,
  };
});

@customElement({
  name: 'spark-line',
  template: html<SparkLine>`
    <rapid-g2plot-chart
      type="column"
      :config=${(x) => x.chartConfig}
      :data=${() => data}
    ></rapid-g2plot-chart>
  `,
  styles: css``,
})
export class SparkLine extends GenesisElement {
  chartConfig = {
    width: 700,
    xField: 'label',
    yField: 'value',
    tooltip: {
      showMarkers: false,
      formatter: () => null,
    },
    xAxis: false,
    yAxis: false,
    legend: {
      itemWidth: 0,
      itemHeight: 0,
    },
    marginRatio: 0.1,
    label: false,
  };
}
